import React from 'react';
import classNames from 'classnames';

interface CardProps {
	className?: string;
	icon?: React.ReactNode;
	title: React.ReactNode;
	description?: React.ReactNode;
	href?: string;
	target?: string;
	onClick?: () => void;
	makeButton?: boolean;
	disabled?: boolean;
	/** Tailwind classes applied to the icon badge — use to recolour it per card (e.g. destructive actions). */
	iconClassName?: string;
}

const CARD_CLASS =
	'group flex min-h-[7.5rem] flex-col gap-3 rounded-xl border border-gray-200 bg-white p-5 ' +
	'text-left !no-underline shadow-sm transition hover:border-gray-300 hover:shadow-md focus:outline-none ' +
	'focus-visible:ring-2 focus-visible:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-60';

export default function Card(props: CardProps) {
	const { className, icon, title, description, href, target, onClick, makeButton, disabled, iconClassName } = props;

	const content = (
		<>
			{icon && (
				<span
					className={classNames(
						'flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 ' +
							'text-blue-600 transition group-hover:bg-blue-100',
						iconClassName,
					)}
				>
					{icon}
				</span>
			)}
			<div className="flex flex-col gap-1">
				<h4 className="text-base font-semibold text-gray-900">{title}</h4>
				{description && <p className="text-sm text-gray-500">{description}</p>}
			</div>
		</>
	);

	if (makeButton) {
		return (
			<button
				type="button"
				className={classNames(CARD_CLASS, 'cursor-pointer', className)}
				onClick={onClick}
				disabled={disabled === true}
			>
				{content}
			</button>
		);
	}

	return (
		<a
			href={href}
			target={target ?? '_blank'}
			rel="noreferrer"
			className={classNames(CARD_CLASS, 'cursor-pointer', className)}
		>
			{content}
		</a>
	);
}
